import { render, staticRenderFns } from "./overdue-payment.vue?vue&type=template&id=b9805220&"
import script from "./overdue-payment.vue?vue&type=script&lang=js&"
export * from "./overdue-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports